module.exports = __webpack_public_path__ + "assets/img/robot.497169bb.svg";